import { useEffect } from 'react';
import { useExperienceTracker } from '../context';
export function ExperienceSuccess(_ref) {
  var name = _ref.name,
    nameId = _ref.nameId,
    attributes = _ref.attributes;
  var experienceTracker = useExperienceTracker();
  useEffect(function () {
    return experienceTracker.succeed({
      name: name,
      nameId: nameId,
      attributes: attributes
    });
  }, [name, nameId, attributes, experienceTracker]);
  return null;
}